import React, { useContext } from 'react';
import './style/PricePlanCard.scss'
import { useTranslation } from 'react-i18next';
import AppContext from '../../config/AppContext';
import CommonUtil from '../../util/CommonUtils';
import CardButton from './CardButton';
import { Typography } from '@mui/material';
import CustomTypography from '../CustomTypography';


const PricePlanCard = ({ planName = "Premium", price = "16", decimalValue = "00", isActivePlan = false, discountAmt, openBillingDetails = () => { }, isFreeTrail = false, openAddressForm = () => { }  }) => {
    const { t } = useTranslation();
    const { mode } = useContext(AppContext);

    const typographyStyle = {
        fontFamily: "GothamMedium",
        textOverflow: "ellipsis", // Corrected typo
        whiteSpace: "nowrap",
        overflow: "hidden",
        color: isActivePlan ? "#242424" : (mode === "dark" ? "#f8f8f8cc" : "#242424"),
        fontSize: "24px",
        lineHeight: "29px",
        width:"230px",
        '@media (max-width: 1600px)': {
            fontSize: "21px",
            lineHeight: "24px",
        },
        paddingTop: CommonUtil.getOS() === "MacOS" ? "4px" : 0
    }
    return (
        <div className='price-plan-card-main'
            style={{
                background: mode === "dark" ? isActivePlan ? "#A49DC8" : "#333333" :
                    isActivePlan ? "rgba(164, 157, 200, 0.15)" : "#FFFFFF",
            }}
        >
            <div className='price-plan-card-content'>
                <div
                    style={{
                        width: "250px",
                        textAlign: "center"
                    }}
                >
                    <CustomTypography title={planName}
                        component={{
                            typography: {
                                sx: { ...typographyStyle }
                            }
                        }}
                    >{planName}</CustomTypography>
                </div>

                <p className='plan-price'
                    style={{
                        color: isActivePlan ? "#242424" : (mode === "dark" ? "#f8f8f8cc" : "#242424"),
                    }}
                >$ {price}.<span className='decimal-part'
                    style={{
                        color: mode === "dark" ? "#F8F8F880" : "#24242480",
                    }}
                >{decimalValue}</span></p>
                {!isFreeTrail && <Typography
                    sx={{
                        color: isActivePlan ? "#242424" : (mode === "dark" ? "#f8f8f8cc" : "#242424"),
                    }}
                >{t("RAL0834")}</Typography>}
            </div>
            {!isActivePlan &&
                // <button className="price-plan-card-button" >{t("RAL0833")}</button>
                <CardButton
                    variant={"contained"}
                    id="btn-subscription"
                    name="btn-subscription"
                    fullWidth={true}
                    // onClick={() => openBillingDetails()}
                    onClick={() => openAddressForm()}
                >
                    {t("RAL0833")}
                </CardButton>
            }
            {(discountAmt !== undefined && !CommonUtil.isEmptyString(discountAmt)) && <div className='discountAmt-container'>
                {discountAmt}%
            </div>}
        </div>
    )
}

export default PricePlanCard
